import { trigger, transition, style, animate } from '@angular/animations';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { UserProfileModel } from 'src/app/nutrigenic/models/profile/user-profile-model';
import { UserProfileService } from 'src/app/nutrigenic/services/profile/user-profile.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    animations: [
        trigger(
          'enterAnimation', [
            transition(':enter', [
              style({transform: 'translateX(-100%)', opacity: 0}),
              animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
            ])
          ]
        ),
        trigger('fade_obj', [ 
            transition('void => *', [
                style({ opacity: 0 }), 
                animate(500, style({opacity: 1}))
            ]) 
        ])
    ],
    styleUrls: ['./account.component.scss']
})
export class AccountComponent {
    userProfile: UserProfileModel = new UserProfileModel();
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;


    constructor(
        private userProfileService: UserProfileService,
        private sizedetection: ResizeDetectionService,
        private cdr: ChangeDetectorRef
    ) { }    


    
    ngOnInit(){
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;

        });
        this.fetchData();        
    }


    fetchData() {
        this.userProfileService.getUserProfile().subscribe({
            next:  (userProfile) => this.handleGetUserProfileResponse(userProfile),
            error: this.handleError.bind(this)
        });
       
    }

    handleGetUserProfileResponse(userProfile: UserProfileModel) {

        this.userProfile = userProfile;
        this.cdr.detectChanges();
    }

    handleError(error: any): void {
        console.error(error);
        Notify.failure('Operation Unsuccessful', {
            position: 'right-top',
            timeout: 3000
        });
    }

    updateProfile(){
        this.userProfileService.updateProfile(this.userProfile).subscribe({
            next: this.handleSuccessResponseProfile.bind(this),
            error: (error) => this.handleError(error)
        });
            
    }

    onDialogHide() {
       
    }

    handleSuccessResponseProfile(response: any): void {
        localStorage.setItem('userName', response.body.first_name + " " + response.body.last_name);
        this.handleSuccessResponse();
    }

    handleSuccessResponse(): void {
        localStorage.removeItem('profile');
        this.fetchData();
        Notify.success('Operation successful', {
            position: 'right-top',
            timeout: 3000
        });
    }


    onFileSelectedProfilePhoto(event: any) {
        const file: File = event.target.files[0];
        if (file) {
            this.userProfileService.setUserPicturePicture(file).subscribe({
                next: this.handleSetUserProfilePictureResponse.bind(this),
                error: this.handleErrorProfilePicture.bind(this)  
            });
        }
    }


    handleSetUserProfilePictureResponse() {
        this.userProfileService.getUserProfile().subscribe({
            next: this.handleGetUserProfileResponse.bind(this),
            error: this.handleError.bind(this)
        });
        Notify.success('Profile Picture Changed', {
            position: 'right-top',
            timeout: 3000
        });
    }

    handleErrorProfilePicture() {
        Notify.failure('Error', {
            position: 'right-top',
            timeout: 3000
        });
    }

    openBillingDetails() {
        window.open(environment.stripe_customer_billing_details_update_url, '_blank');
    }

}